import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathPi = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M18.25 1.75H7c-2.494 0-4.5.25-5.25 3.5m5.5-3.5V12c0 2 0 3.624-2.5 6.25M18.25 16a2.25 2.25 0 0 1-4.5 0V1.75"
	})]
});
const ForwardRef = forwardRef(SvgMathPi);
export { ForwardRef as ReactComponent };
